import { render, staticRenderFns } from "./InitialView.vue?vue&type=template&id=0a5dd46a"
import script from "./InitialView.vue?vue&type=script&lang=js"
export * from "./InitialView.vue?vue&type=script&lang=js"
import style0 from "./InitialView.vue?vue&type=style&index=0&id=0a5dd46a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports